<template>
  <v-app>
    <v-app-bar
      app
      clipped-right
      fixed
      absolute
      dark
      color="dtv-app-bar"
      v-if="showbar"
      class="d-print-none"
    >
      <v-spacer />
      <v-toolbar-title>
        <v-img src="/images/dtvlogo.svg" max-width="130" />
      </v-toolbar-title>
      <v-spacer />
      <template v-if="showBetaFeatures && $vuetify.breakpoint.mdAndUp">
        <template v-for="item in items">
          <v-btn
            :key="item.title"
            v-if="!!item.to"
            active-class="active-website-button"
            exact
            :to="item.to"
            class="text-none"
            :dark="!!item.color"
            :text="!item.color"
            :color="item.color ? item.color : ''"
            >{{ item.title }}</v-btn
          >
          <div :key="item.title" v-if="!!item.method">
            <v-btn
              exact
              class="text-none"
              @click="handle_function_call(item.method)"
              block
              :dark="!!item.color"
              :text="!item.color"
              :color="item.color ? item.color : ''"
              >{{ item.title }}</v-btn
            >
          </div>
          <div :key="item.title" v-if="!!item.href">
            <v-btn
              exact
              class="text-none"
              :href="item.href"
              block
              :dark="!!item.color"
              :text="!item.color"
              :color="item.color ? item.color : ''"
              >{{ item.title }}</v-btn
            >
          </div>
        </template>
        <div>
          <v-btn
            class="text-none"
            block
            text
            v-if="authenticated"
            @click="logout"
            >Logout</v-btn
          >
        </div>
      </template>
      <template v-else>
        <v-app-bar-nav-icon v-if="showBetaFeatures" @click="toggleDrawer"></v-app-bar-nav-icon>
      </template>
      <v-btn
        id="help_print"
        @click="print"
        color="primary"
        v-if="$route.meta.printable"
      >
        <v-icon left> mdi-printer </v-icon>
        Print</v-btn
      >
    </v-app-bar>
    <v-main>
      <router-view></router-view>
      <v-row>
        <v-col
          v-if="showAds"
          cols="12"
          class="pa-0 justify-center d-print-none"
        >
          <google-ad />
        </v-col>
      </v-row>
    </v-main>
    <v-navigation-drawer v-if="showBetaFeatures" app clipped right temporary v-model="isDrawerOpen">
      <v-list dense nav>
        <v-list-item-group class="text-center">
          <template v-if="showBetaFeatures">
            <template v-for="item in items">
              <v-btn
                :key="item.title"
                v-if="!!item.to"
                active-class="active-website-button"
                class="text-none"
                exact
                :to="item.to"
                block
                :dark="!!item.color"
                :text="!item.color"
                :color="item.color ? item.color : ''"
                >{{ item.title }}</v-btn
              >
              <div :key="item.title" v-if="!!item.method">
                <v-btn
                  exact
                  class="text-none"
                  @click="handle_function_call(item.method)"
                  block
                  :dark="!!item.color"
                  :text="!item.color"
                  :color="item.color ? item.color : ''"
                  >{{ item.title }}</v-btn
                >
              </div>
              <div :key="item.title" v-if="!!item.href">
                <v-btn
                  exact
                  class="text-none"
                  :href="item.href"
                  block
                  :dark="!!item.color"
                  :text="!item.color"
                  :color="item.color ? item.color : ''"
                  >{{ item.title }}</v-btn
                >
              </div>
            </template>
          </template>
          <v-btn
            class="text-none"
            text
            block
            v-if="authenticated"
            @click="logout"
            >Logout</v-btn
          >
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-dialog
      v-model="authDialog"
      width="500"
      scrollable
      content-class="top-align-dialog"
    >
      <login-form v-if="currentForm === 'login'" />
      <register-form v-if="currentForm === 'register'" />
    </v-dialog>
  </v-app>
</template>

<script>
import LoginForm from "./shared/LoginForm";
import RegisterForm from "./shared/RegisterForm";

import { UPDATE_FORM, TOGGLE_AUTH_DIALOG, LOGOUT } from "../store/actions.type";
import GoogleAd from "../components/Home/GoogleAdPostscribe";

export default {
  name: "App",
  components: {
    LoginForm,
    RegisterForm,
    GoogleAd,
  },
  data() {
    return {
      isDrawerOpen: false,
      beforeItems: [{ title: "Home", to: "/" }],
      guestItems: [{ title: "Planner", method: "login" }],
      authItems: [],
      adminItems: [],
      customerItems: [
        { title: "Planner", to: "/screens" },
        { title: "Settings", to: "/settings" },
      ],
      afterItems: [],
      showAds: process.env.MIX_ADS_ENABLED === "true",
    };
  },
  computed: {
    showbar() {
      return this.$route.meta.showbar;
    },
    items: function () {
      let roles = this.$store.getters.currentRoles;
      let tempItems;
      tempItems = [];

      Array.prototype.push.apply(tempItems, this.beforeItems);
      //Role routes first
      roles.forEach((role) => {
        Array.prototype.push.apply(tempItems, this[role + "Items"]);
      });

      //Then Auth or Guest Routes
      if (this.authenticated) {
        Array.prototype.push.apply(tempItems, this.authItems);
      } else {
        Array.prototype.push.apply(tempItems, this.guestItems);
      }
      //The After Items
      Array.prototype.push.apply(tempItems, this.afterItems);
      return tempItems;
    },
    authenticated() {
      return this.$store.getters.isAuthenticated;
    },
    currentForm() {
      return this.$store.getters.currentForm;
    },
    authDialog: {
      get: function () {
        return this.$store.getters.currentAuthDialogState;
      },
      // setter
      set: function () {
        this.$store.dispatch(TOGGLE_AUTH_DIALOG);
      },
    },
  },
  methods: {
    login() {
      this.$store.dispatch(UPDATE_FORM, "login").then(() => {
        this.$store.dispatch(TOGGLE_AUTH_DIALOG);
      });
    },
    logout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "home" }));
    },
    hasRole(role) {
      return this.$store.getters.hasRole(role);
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
@media print {
  .v-main {
    padding: 0 !important;
  }
}
.dtv-app-bar {
  background-color: #1d2329;
}
</style>